import NavLink from "../NavLink";
import styles from "./styles.module.css";

export default function Footer() {
  return (
    <div className={styles.footer}>
      <p>© 2020 – {new Date().getFullYear()} Playvision L.L.C-FZ. All rights reserved.</p>
      <div className={styles.navlist}>
        <NavLink className={styles.footerLink} href="/privacy-policy.html">
          Privacy Policy
        </NavLink>
        <NavLink className={styles.footerLink} href="/terms-of-use.html">
          Terms of Use
        </NavLink>
        {/*<NavLink to="terms">Оферта</NavLink>*/}
        <NavLink className={styles.footerLink} href="https://vk.com/im?sel=-140415383">
          Поддержка
        </NavLink>
      </div>
      <div className={styles["payment-logos"]}>
        <img src="/mir-logo.png" alt="Mir" />
        <img src="/sbp-logo.svg" alt="СБП" />
      </div>
    </div>
  );
}
